import { Box, VStack } from "@chakra-ui/react";
import { useSearchParams } from "react-router-dom";

import GroupCard from "~/components/groups/GroupCard";

const GroupPage = () => {
  const [searchParams] = useSearchParams();
  const isNewGroup = searchParams.get("new") === "true";

  return (
    <Box maxW="1200px" mx="auto" p={5}>
      <VStack spacing={8} align="stretch">
        <GroupCard initialEditMode={isNewGroup} />
      </VStack>
    </Box>
  );
};

export default GroupPage;
